import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IUserLogGroup } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class UsersLogsGroupsApiClient extends BaseApiClient<IUserLogGroup, any, FilterQuery<IUserLogGroup>, IUserLogGroup, IUserLogGroup> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.usersLogsGroups}`
    super({
      apiUrl: baseUrl,
      axios
    })
  }
}